import { useEffect, useState } from "react";
import getFavorites from "../utils/helpers/getFavorites";

export function useFavorite(widgetId: string): [boolean, () => void] {
  const [favorites, setFavorites] = useState(() => getFavorites());
  const isFavorite = favorites.includes(widgetId);

  // TODO: rewrite this using store when it will be implemented
  useEffect(() => {
    localStorage.setItem("favorites", JSON.stringify(favorites));
    window.dispatchEvent(new Event("storage"));
  }, [favorites]);

  const toggleFavorite = () => {
    let favs = getFavorites();
    favs.includes(widgetId)
      ? (favs = favs.filter((item) => item !== widgetId))
      : favs.push(widgetId);
    setFavorites(favs);
  };

  return [isFavorite, toggleFavorite];
}
